/** Dernière étape avant page succès (récap + envoi) */
export const STEP_SUCCESS = 15;

/** Page récapitulatif */
export const STEP_RECAP = 14;

/** Dernière étape de saisie (formules) */
export const STEP_FORMULAS = 13;

export const WIZARD_STEP_LABELS = [
	'Informations sur le Projet',
	"Informations sur l'Émetteur",
	'Services',
	'Données touristiques',
	'Visuel et Support',
	'Dispositifs de Lecture',
	'Site Web Dédié au Pass',
	'Réseaux Sociaux dédiés au Pass',
	'Inscriptions & Boutique en ligne',
	'Gestion financière',
	'Langues, couleurs et Divers',
	'Contacts',
	'Formules',
	'Récapitulatif',
];

/** Nombre affiché dans « Étape x / N » (inclut le récapitulatif) */
export const WIZARD_STEP_COUNT_UI = 14;

export function getInitialFormData() {
	return {
		project_type: 'ot',
		support_dematerialise: 'oui',
		support_physique: 'non',
		langues_backoffice: ['Français', 'Anglais'],
		front_languages: ['Français', 'Anglais'],
		pays: 'France',
		/** @type {string[]} codes ISO 4217 */
		finance_currencies_iso: ['EUR'],
		/** @type {1|2|3} aligné ANNUALY / QUARTERLY / MONTHLY */
		finance_periodicity_entries: 2,
		/** @type {1|2|3} */
		finance_periodicity_sales: 2,
		formules: [
			{
				package: '',
				reference: '',
				duree: '',
				periode: '',
				tarifAdulte: '',
				tarifEnfant: '',
				accompagnants: '',
			},
		],
	};
}
